/**
 * Runtime config accessor.
 *
 * In production containers, /config.js is generated by the Docker entrypoint
 * at container start and sets window.__APP_CONFIG__ before the app bundle runs.
 * In dev, public/config.js ships empty defaults and import.meta.env.VITE_* is used.
 *
 * This lets a single built image run in any environment by swapping env vars.
 */

type AppConfig = {
  VITE_FIREBASE_API_KEY?: string;
  VITE_FIREBASE_AUTH_DOMAIN?: string;
  VITE_FIREBASE_PROJECT_ID?: string;
  VITE_FIREBASE_STORAGE_BUCKET?: string;
  VITE_FIREBASE_MESSAGING_SENDER_ID?: string;
  VITE_FIREBASE_APP_ID?: string;
  VITE_WS_SERVER_URL?: string;
  VITE_USE_MOCK_AUTH?: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const runtime: AppConfig =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

export function getConfig(key: keyof AppConfig): string | undefined {
  const fromRuntime = runtime[key];
  if (fromRuntime && fromRuntime.length > 0) return fromRuntime;
  const fromBuild = import.meta.env[key] as string | undefined;
  return fromBuild && fromBuild.length > 0 ? fromBuild : undefined;
}
